import { memo, useMemo } from "react";

import { Breadcrumbs } from "@components/Breadcrumbs";
import { useCollectionQuery } from "@react/sections/Collection/useCollectionQuery";

type props = {
  breadcrumbsLabel: string;
  collectionHandle: string;
  homeLabel: string;
  isLoading?: boolean;
};

const CollectionBreadcrumbsBase = ({
  breadcrumbsLabel,
  collectionHandle,
  homeLabel,
  isLoading = false,
}: props) => {
  const { breadcrumbs, handle, title } = useCollectionQuery(collectionHandle);

  const breadcrumbLinks = useMemo(() => {
    const collectionUrl = `/collections/${handle}`;

    return [
      ...(breadcrumbs?.map((breadcrumb) => ({
        title: breadcrumb.titleOverride?.value ?? breadcrumb.title,
        url: breadcrumb.onlineStoreUrl ?? "",
      })) ?? []),
      { title: title ?? "", url: collectionUrl },
    ];

    return [];
  }, [breadcrumbs, handle, title]);

  return (
    <Breadcrumbs
      breadcrumbsLabel={breadcrumbsLabel}
      homeLabel={homeLabel}
      isLoading={isLoading}
      items={breadcrumbLinks}
    />
  );
};

export const CollectionBreadcrumbs = memo(CollectionBreadcrumbsBase);
